import collectionPoster from '@/assets/images/katsura-royal-collection.png';

export const order = 1;

export default {
  collection_name: 'Katsura Royal Collection',
  collection_desc:
    'Discover the epitome of elegance and craftsmanship with the Katsura Royal Collection. This exquisite line of hardwood flooring embodies a seamless fusion of traditional artistry and Japanese-inspired technique and innovation. Each plank is meticulously crafted with refined methods and exacting standards, reflecting a legacy of precision, balance, and enduring beauty.',
  collection_poster:
    collectionPoster,
  products: [
    {
      product_name: 'Morning Fog',
      sku: 'KRJ01',
      product_desc:
        'Morning Fog captures the serene beauty of misty mornings with soft beige tones, warm greige undertones, and delicate natural oak grain. Crafted from premium Japanese White Oak, its subtle color variations and refined textures bring warmth, tranquility, and timeless elegance to any space. Perfect for modern, Scandinavian, and traditional interiors, Morning Fog creates a sophisticated yet inviting atmosphere, blending natural beauty with understated luxury.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Morning%20Fog/Morning%20Fog%20Interior01.jpeg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Morning%20Fog/Morning%20Fog1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Morning%20Fog/Morning%20Fog2.jpg',
        },
      ],
      product_galleries_video: [],
      product_attributes: [
        ['Color', 'Morning Fog'],
        ['Grade', 'Prime'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Misty White Oak',
      sku: 'KRJ02',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Misty%20White%20Oak/Misty%20White%20Oak%20Interior01.png',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Misty%20White%20Oak/Misty%20White%20Oak%20Interior02.jpg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Misty%20White%20Oak/Misty%20White%20Oak1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Misty%20White%20Oak/Misty%20White%20Oak2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Misty%20White%20Oak/Misty%20White%20Oak3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Misty%20White%20Oak/Misty%20White%20Oak4.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Misty%20White%20Oak/Misty%20White%20Oak5.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Misty%20White%20Oak/Misty%20White%20Oak%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Misty%20White%20Oak/Misty%20White%20Oak1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Misty White Oak'],
        ['Grade', 'Prime'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Misty Coastal Sand',
      sku: 'KRJ07',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative.',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Misty%20Coastal%20Sand/Misty%20Coastal%20Sand%20Interior01.png',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Misty%20Coastal%20Sand/Misty%20Coastal%20Sand%20Interior02.jpg',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Misty%20Coastal%20Sand/Misty%20Coastal%20Sand1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Misty%20Coastal%20Sand/Misty%20Coastal%20Sand2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Misty%20Coastal%20Sand/Misty%20Coastal%20Sand3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Misty%20Coastal%20Sand/Misty%20Coastal%20Sand4.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Misty%20Coastal%20Sand/Misty%20Coastal%20Sand5.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Misty%20Coastal%20Sand/Misty%20Coastal%20Sand%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Misty%20Coastal%20Sand/Misty%20Coastal%20Sand1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Misty Coastal Sand'],
        ['Grade', 'Character (ABCD)'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Harvest Wheat',
      sku: 'KRJ04',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Harvest%20Wheat/Harvest%20Wheat%20Interior01.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Harvest%20Wheat/Harvest%20Wheat1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Harvest%20Wheat/Harvest%20Wheat2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Harvest%20Wheat/Harvest%20Wheat3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Harvest%20Wheat/Harvest%20Wheat4.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Harvest%20Wheat/Harvest%20Wheat5.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Harvest%20Wheat/Harvest%20Wheat6.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Harvest%20Wheat/Harvest%20Wheat%20Video%2001.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Harvest%20Wheat/Harvest%20Wheat1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Harvest Wheat'],
        ['Grade', 'Character (ABCD)'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Honey Amber 9.5',
      sku: 'KRJ09',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Honey%20Amber%209.5/Honey%20Amber%209.5%20Interior01%20.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Honey%20Amber%209.5/Honey%20Amber%209.5%20Interior02.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Honey%20Amber%209.5/Honey%20Amber%209.5_1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Honey%20Amber%209.5/Honey%20Amber%209.5_2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Honey%20Amber%209.5/Honey%20Amber%209.5_3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Honey%20Amber%209.5/Honey%20Amber%209.5_4.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Honey%20Amber%209.5/Honey%20Amber%209.5%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Honey%20Amber%209.5/Honey%20Amber%209.5_1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Honey Amber 9.5'],
        ['Grade', 'Character (ABCD)'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Golden Ash',
      sku: 'KRJ03',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Golden%20Ash/Golden%20Ash%20interior%2001.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Golden%20Ash/Golden%20Ash1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Golden%20Ash/Golden%20Ash2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Golden%20Ash/Golden%20Ash3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Golden%20Ash/Golden%20Ash4.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Golden%20Ash/Golden%20Ash5.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Golden%20Ash/Golden%20Ash%20video%2001.mkv',
          poster: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Golden%20Ash/Golden%20Ash1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Golden Ash'],
        ['Grade', 'Prime'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Vanilla',
      sku: 'KRJ32',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Vanilla/Vanilla%20interior%2001.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Vanilla/Vanilla01.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Vanilla/Vanilla02.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Vanilla/Vanilla03.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Vanilla/Vanilla04.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Vanilla/Vanilla05.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Vanilla/Vanilla%20Video%2001.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Vanilla/Vanilla01.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Vanilla'],
        ['Grade', 'Prime'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
    {
      product_name: 'Natural Ash',
      sku: 'KRA03',
      product_desc:
        'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative',
      product_galleries_interior_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Natural%20Ash/Natural%20Ash%20interior%2001.png',
        },
      ],
      product_galleries_normal_img: [
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Natural%20Ash/Natural%20Ash1.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Natural%20Ash/Natural%20Ash2.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Natural%20Ash/Natural%20Ash3.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Natural%20Ash/Natural%20Ash4.jpg',
        },
        {
          type: 'image',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Natural%20Ash/Natural%20Ash5.jpg',
        },
      ],
      product_galleries_video: [
        {
          type: 'video',
          url: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Natural%20Ash/Natural%20Ash%20Video01.mp4',
          poster: 'https://cdn.sakurafloors.com/products/Katsura%20Royal%20Collection/Natural%20Ash/Natural%20Ash1.jpg',
        },
      ],
      product_attributes: [
        ['Color', 'Natural Ash'],
        ['Grade', 'Prime'],
        ['Wear Layer', '4mm'],
        ['Width', '9.5"'],
        ['Thickness', '5/8"'],
        ['Length', 'Up to 86" with 70% full length'],
        ['Species', 'Oak'],
        ['Texture', 'Light Wire Brushed'],
        ['Finish', 'UV Urethane'],
        ['Install Method', 'Glue-down, Nail + Glue, or Float'],
        ['Warranty', '25 years residential finish warranty, 3 years commercial finish warranty, Limited lifetime structural warranty'],
        ['Natural Color Variation', 'This collection has color tones ranging from light to dark. Wood is a natural product with inherent color, texture, and grain that may not be fully represented in this sample or room scene. Actual color and grain pattern may vary. Please consult with your sales representative'],
        ['TSCA EPA Title VI Certified', ''],
        ['CARB Phase 2 Compliant', ''],
      ],
    },
  ],
};
